module.exports = __webpack_public_path__ + "img/img_app_hover.4c4edb1e.svg";